import { Component, OnInit, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SubscriptionService } from 'app/services/subscription.service';
import { Globals } from "../globals";
import { ProperityService } from '../services/properity.service';
import * as moment from 'moment';

@Component({
  selector: 'app-subscription-update-price',
  templateUrl: './subscription-update-price.component.html',
  styleUrls: ['./subscription-update-price.component.css']
})
export class SubscriptionUpdatePriceComponent implements OnInit {

  subscription: any = {};
  cars: any = [];
  sendNotification: boolean = false;
  message: string = "";
  newPaidStatus: boolean = false;
  newTotalArea: number = 0;
  allowUpdate: boolean = false;
  installmentsArr: any = [];
  showPayInstallmed: boolean = false;
  installmentID: string = "";
  showApproveWhenInstallments: boolean = false;
  visits: any = [];
  showUpdate: boolean = false;
  disableTime: boolean = false;
  areaDetails: any = [];
  selectedArea: any = {};
  selectedAreaIndex = -1;
  surveyDate: any = "";

  constructor(
    public dialogRef: MatDialogRef<SubscriptionUpdatePriceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private subscriptionService: SubscriptionService, private globals: Globals, private properityService: ProperityService) {
    this.subscription = data.subscription;
    this.allowUpdate = data.allowUpdate;
    this.newPaidStatus = this.subscription.paid;

    if ((this.subscription.moreDetailsType == "GARDEN_AREA" || this.subscription.moreDetailsType == "SP_AREA") && this.subscription.moreDetails != "") {
      var jsonData = JSON.parse(this.subscription.moreDetails);
      this.subscription.totalArea = this.newTotalArea = jsonData[0]?.area ? jsonData[0].area : 0;
      if (this.subscription.moreDetailsType == "GARDEN_AREA" && this.subscription.totalPrice && this.subscription.totalArea) {
        this.subscription.item.price = this.subscription.totalPrice / this.subscription.totalArea;
      }
    }
    else if ((this.subscription.moreDetailsType == "HOUSE_KEEPING_VISIT") && this.subscription.moreDetails != "") {
      var jsonData = JSON.parse(this.subscription.moreDetails);
      this.subscription.totalArea = this.newTotalArea = (jsonData && jsonData.numberOfVisits) ? jsonData.numberOfVisits : 0;
      if (jsonData?.visitDates) {
        this.disableTime = true;
        this.visits = jsonData?.visitDates;
      }
      else {
        this.addVisits();
      }
      this.showUpdate = this.subscription.status == 'PENDING' ? true : false;
    }
    else if (this.subscription.moreDetailsType == "CAR_DETAIL") {
      this.cars = JSON.parse(this.subscription.moreDetails);
    }
    else if (this.subscription.moreDetailsType == "PEST_CONTROL") {
      this.areaDetails = JSON.parse(this.subscription.item.moreDetails);
      this.showUpdate = this.subscription.status == 'PENDING' ? true : false;
      let subDetails = JSON.parse(this.subscription.moreDetails);
      this.surveyDate = subDetails?.surveyDate;
      if (subDetails.areaDetail) {
        this.selectedArea = subDetails.areaDetail;
        this.selectedAreaIndex = this.areaDetails.findIndex(item => item.area == this.selectedArea.area);
      }
    }
    if (this.subscription.paymenttype == "INSTALLMENT") {
      this.getInstallments(this.subscription.subscriptionId);
    }
  }

  ngOnInit() {
  }

  addVisits() {
    this.visits = [];
    for (let i = 0; i < this.newTotalArea; i++) {
      this.visits.push({
        id: i,
        date: "",
        time: ""
      });
    }
  }

  getInstallments(id) {
    this.subscriptionService.getInstallments(id).subscribe(result => {
      this.installmentsArr = result.map(item => {
        item.from = this.getDate(item.from) + " : " + this.getDate(item.to);
        item.amount = item.amount ? item.amount : 0;
        item.checked = (item.paymentStatus == "PAID") ? true : false;
        if (item.paymentStatus == "PAID") {
          this.showApproveWhenInstallments = true;
        }
        return item;
      });
    });
  }

  onClickCancel(): void {
    this.dialogRef.close();
  }

  approve() {
    this.saveArea();
  }

  saveArea() {
    var tempArr = [];
    var data: any = {
      moreDetails: "",
      moreDetailsType:
        this.subscription.item.type.serviceCode === "C002" ? "GARDEN_AREA" : "SP_AREA",
      subscriptionId: this.subscription.subscriptionId,
      paid: this.newPaidStatus
    };

    if (this.subscription.item.type.serviceCode === 'C005') {
      data.moreDetails = JSON.stringify({ numberOfVisits: this.newTotalArea, visitDates: this.visits });
      data.moreDetailsType = "HOUSE_KEEPING_VISIT";
    }
    else if (this.subscription.item.type.serviceCode === 'C003') {
      data.moreDetails = JSON.stringify({ areaDetail: this.selectedArea, surveyDate: this.surveyDate });
      data.moreDetailsType = "PEST_CONTROL";
    }
    else {
      tempArr.push({ area: this.newTotalArea });
      data.moreDetails = JSON.stringify(tempArr);
    }

    this.subscriptionService.UpdateSubscription(data).subscribe((a) => {
      this.globals.presentSuccessToast("Subscription has been approved successfully");
      this.dialogRef.close(true);
    });
  }

  updatePaidStatus() {
    var data = {
      "subscriptionId": this.subscription.subscriptionId,
      "paid": this.newPaidStatus,
    }
    this.subscriptionService.updateSubscriptionPaidFlag(data).subscribe(result => {
      this.globals.presentSuccessToast("Subscription has been updated successfully");
      this.subscription.paid = this.newPaidStatus;
      this.dialogRef.close(true);
    });
  }

  getDate(date) {
    return moment(date).format('L');
  }

  checkedChanged(evt, item) {
    this.showPayInstallmed = evt.checked;
    this.installmentID = item.checked ? item.id : "";
  }

  payInstallment() {
    var data = {
      "installmentId": this.installmentID,
      "paid": true,
    }
    this.subscriptionService.updateInstallment(data).subscribe(result => {
      this.globals.presentSuccessToast("Subscription has been updated successfully");
      this.subscription.paid = this.newPaidStatus;
      this.dialogRef.close(true);
    });
  }

  approveSubscription() {
    var data = {
      "subscriptionId": this.subscription.subscriptionId,
    }
    this.subscriptionService.approveSubscription(data).subscribe(result => {
      this.globals.presentSuccessToast("Subscription has been updated approved");
      this.dialogRef.close(true);
    });
  }

  dateChanged(index) {
    let element: any = document.getElementsByClassName("date")[index];
    this.visits[index].time = this.formatTime(element.value);
  }

  formatTime(time) {
    let temp = time.split(":");
    return Number(temp[0]) > 12 ? (temp[0] - 12 + ":" + temp[1] + " PM") : (temp[0] + ":" + temp[1] + " AM");
  }

  getDisableBtn() {
    let disableBtn = false;
    if (this.showUpdate) {
      if (this.subscription.item.type.serviceCode == 'C005') {
        for (var i = 0; i < this.visits.length; i++) {
          if (!this.visits[i].date || !this.visits[i].time) {
            disableBtn = true;
          }
        }
      }
      else if (this.subscription.item.type.serviceCode == 'C003') {
        return this.selectedAreaIndex != -1 ? false : true;
      }
    }
    return disableBtn;
  }

  areaChanged(evt) {
    this.selectedArea = this.areaDetails[evt.value];
    this.selectedAreaIndex = evt.value;
  }
}

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}